"use client";

import { memo } from "react";
import { Box, HStack, VStack, Text, Heading } from "@chakra-ui/react";
import type { AtsBasicInfo } from "../types";

export interface ResumeHeaderProps {
  basicInfo: AtsBasicInfo;
}

export const ResumeHeader = memo<ResumeHeaderProps>(({ basicInfo }) => {
  const websiteUrl = basicInfo.linkedin || basicInfo.github || "";

  return (
    <Box as="header" role="banner" mb={6} id="resume-header">
      <HStack
        justify="space-between"
        align="flex-start"
        wrap="wrap"
        gap={4}
        w="full"
      >
        <VStack align="start" gap={0} flex={1}>
          <Heading
            as="h1"
            textStyle="4xl"
            fontWeight="semibold"
            color="primary.600"
            lineHeight="1.5"
          >
            {basicInfo.name}
          </Heading>
          {basicInfo.job_title && (
            <Text textStyle="md" fontWeight="base" color="neutral.600">
              {basicInfo.job_title}
            </Text>
          )}
        </VStack>
        <VStack
          align="end"
          gap={0.5}
          textStyle="sm"
          color="neutral.500"
          lineHeight="1.6"
        >
          {basicInfo.phone && <Text>{basicInfo.phone}</Text>}
          {basicInfo.email && <Text>{basicInfo.email}</Text>}
          {websiteUrl && (
            <Text>
              <a
                href={websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#333", textDecoration: "none" }}
              >
                {websiteUrl.replace(/^https?:\/\//, "").replace(/^www\./, "")}
              </a>
            </Text>
          )}
          {basicInfo.address && <Text>{basicInfo.address}</Text>}
        </VStack>
      </HStack>
      <Box height="1px" mt={3} width="100%" />
    </Box>
  );
});
ResumeHeader.displayName = "ResumeHeader";
